import classNames from "classnames";
import { JAVASCRIPT_VOID } from "constant/config";
import { SMR } from "constant/maintype";
import { getSessionItem, gtag, handleFailedToFetch, handleFetchErrors, setSessionItem } from "helpers";
import React, { Fragment, useCallback, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { shallowEqual, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router";
import { Link } from "react-router-dom";
import { setClickLogapi } from "helpers";

const ADMIN = 1;
const BORAD = 2;
const VOD = 3;

const Menu = (props) => {
    const { t } = useTranslation();
    const { id } = useParams();
    const location = useLocation();

    const [ adminActive, setAdminActive ] = useState(getSessionItem("adminActive", true));
    const [ vodActive, setVodActive ] = useState(getSessionItem("vodActive", true));
    const [ boardActive, setBoardActive ] = useState(getSessionItem("boardActive", true));
    
    const { station, is_owner, is_best_bj, is_partner_bj, is_sports_bj } = useSelector(({ stationReducer }) => {
        const { stationInfo } = stationReducer;
        const { data } = stationInfo || {};
        const { station, is_owner, is_best_bj, is_partner_bj, is_sports_bj } = data || {};
        
        return {
            station: station, is_owner: is_owner, is_best_bj: is_best_bj, is_partner_bj: is_partner_bj, is_sports_bj: is_sports_bj 
        };
    },shallowEqual);
    
    const { menus, display } = station;
    const { main_type } = display;

    const handleActiveMenu = useCallback((category) => {
        switch (category) {
            case ADMIN:
                setAdminActive(setSessionItem("adminActive", !adminActive))
                break;
            case VOD:
                setVodActive(setSessionItem("vodActive", !vodActive))
                break;
            case BORAD:
                setBoardActive(setSessionItem("boardActive", !boardActive))
                break;
            default:
                break;
        }
    },[adminActive, boardActive, vodActive]);

    const handleMobileNotification = () => {
        const url = "//item.onlive.vn/choco_message.php?szWork=checkUseMessageItem";
        fetch(url, {
            credentials: "include",
        })
            .then(handleFetchErrors, handleFailedToFetch)
            .then((response) => response.json())
            .then((response) => {
                if (response.RET === -1) {
                    alert(t("Đây là một lỗi. lại Thử ước."));
                } else if (response.RET === -2) {
                    alert(t("Đăng nhập sau đó Sử dụng ước."));
                } else if (response.RET === -3) {
                    if (window.confirm(t("mục  Sử dụng Trên trang Bạn có muốn di chuyển?"))) {
                        window.open("//items.onlive.vn/choco/index.php?ctrl=choco_item_user_controller&func=view_item_my_info");
                    }
                } else if (response.RET === -4) {
                    if (window.confirm(t("Bạn đang chưa sở hữu gói tính năng này, có muốn di chuyển đến trang trao đổi?"))) {
                        window.open("//point.onlive.vn/exchange-sticker");
                    }
                } else {
                    window.open("//item.onlive.vn/choco_message.php?szWork=view", "mobile_alim", "width=392 height=435");
                }
            })
            .catch(() => {
                window.open("//item.onlive.vn/choco_message.php?szWork=view", "mobile_alim", "width=392 height=435");
            });
    };

    const getActive = (url, exact = false) => {
        const { pathname, state = {} } = location;
        const { bbs_no } = state;
        const [, path1, path2, path3, path4] = pathname.split("/");
        if (path3 === "write" && path4) {
            //글쓰기
            return url === `/${path1}/posts/${path4}` ? "on" : null;
        } else if (path2 === "post" && !bbs_no) {
            //전체게시판
            return url === `/${path1}/posts` ? "on" : null;
        } else if (path2 === "post" && bbs_no) {
            return url === `/${path1}/posts/${bbs_no}` ? "on" : null;
        } else {
            if (exact) {
                return pathname === url ? "on" : null;
            } else {
                return pathname.indexOf(url) > -1 ? "on" : null;
            }
        }
    };

    return [
        is_owner && (
            <div key={1} className={classNames("menu-list", { active: adminActive })}>
                <h3>
                    <button
                        type="button"
                        onClick={() => {
                            handleActiveMenu(ADMIN);
                        }}
                    >
                        <span>
                            <Trans>Quản lý phát sóng</Trans>
                        </span>
                    </button>
                </h3>
                <ul>
                    <li>
                        {/* onClick 내 함수가 아닌 실행문을 전달할 경우 렌더링 될 때 onClick이벤트가 실행되어버린다. 따라서 함수형으로 선언*/}
                        <a href="https://dashboard.onlive.vn/index.php" target="_blank" rel="noopener noreferrer" onClick={() => {setClickLogapi("station_click", {button_group: "lnb", button_type: "dashboard"})}}>
                            <Trans>Cài đặt phát sóng qua thiết bị ngoại vi</Trans>
                        </a>
                    </li>
                    {/* <li>
                        <a href={JAVASCRIPT_VOID} onClick={handleMobileNotification}>
                            <Trans>Gửi thông báo trên di động</Trans>
                        </a>
                    </li> */}
                </ul>
            </div>
        ),
        <article key={2} className="fix-menu" ref={props.fixBar}>
            <div key={3} className={classNames("menu-list", { active: vodActive })}>
                <h3>
                    <button
                        type="button"
                        onClick={() => {
                            handleActiveMenu(VOD);
                        }}
                    >
                        <span>
                            <Trans>VOD</Trans>
                        </span>
                    </button>
                </h3>
                <ul>
                    <li className={classNames(getActive(`/${id}/vods`, true))}>
                        <Link to={`/${id}/vods`} refresh="true" onClick={gtag("pc_menu", "vod")}>
                            <strong>
                                <Trans>Toàn bộ VOD</Trans>
                            </strong>
                        </Link>
                    </li>
                    {main_type !== SMR && (
                        <Fragment>
                            <li className={classNames(getActive(`/${id}/vods/review`))} onClick={gtag("pc_menu", "review")}>
                                <Link to={`/${id}/vods/review`}>
                                    <Trans>Phát lại</Trans>
                                </Link>
                            </li>
                            <li className={classNames(getActive(`/${id}/vods/normal`))} onClick={gtag("pc_menu", "normal")}>
                                <Link to={`/${id}/vods/normal`}>
                                    <Trans>Tải lên VOD</Trans>
                                </Link>
                            </li>
                            <li className={classNames(getActive(`/${id}/vods/myclip`))} onClick={gtag("pc_menu", "myclip")}>
                                <Link to={`/${id}/vods/myclip`}>
                                    <Trans>Tải lên Clip</Trans>
                                </Link>
                            </li>
                            <li className={classNames(getActive(`/${id}/vods/user`))} onClick={gtag("pc_menu", "user")}>
                                <Link to={`/${id}/vods/user`}>
                                    <Trans>Người dùng VOD</Trans>
                                </Link>
                            </li>
                            <li className={classNames(getActive(`/${id}/vods/clip`))} onClick={gtag("pc_menu", "clip")}>
                                <Link to={`/${id}/vods/clip`}>
                                    <Trans>Clip của người xem</Trans>
                                </Link>
                            </li>
                            <li
                                className={classNames(getActive(`/${id}/vods/balloonclip`))}
                                onClick={gtag("pc_menu", "balloonclip")}
                            >
                                <Link to={`/${id}/vods/balloonclip`}>
                                    <Trans>Clip Bóng bay</Trans>
                                </Link>
                            </li>
                        </Fragment>
                    )}
                    <li className={classNames(getActive(`/${id}/vods/list`))} onClick={gtag("pc_menu", "list")}>
                        <Link to={`/${id}/vods/list`}>
                            <Trans>Danh sách phát</Trans>
                        </Link>
                    </li>

                    <li className={classNames(getActive(`/${id}/vods/catch`))} onClick={gtag("pc_menu", "catch")}>
                        <Link to={`/${id}/vods/catch`}>
                            <Trans>Short</Trans>
                        </Link>
                    </li>

                </ul>
            </div>
            <div key={4} className={classNames("menu-list", { active: boardActive })}>
                <h3>
                    <button
                        type="button"
                        onClick={() => {
                            handleActiveMenu(BORAD);
                        }}
                    >
                        <span>
                            <Trans>Bảng ghi chú</Trans>
                        </span>
                    </button>
                </h3>
                <ul>
                    <li className={classNames(getActive(`/${id}/posts`, true))}>
                        <Link to={`/${id}/posts`} onClick={gtag("pc_menu", "posts")}>
                            <strong>
                                <Trans>Toàn bộ bài viết</Trans>
                            </strong>
                        </Link>
                    </li>
                    {main_type !== SMR &&
                        menus.map((menu, idx) => {
                            switch (menu.display_type) {
                                case 107: //제목
                                    return (
                                        <li key={idx} className="stit">
                                            {menu.name}
                                        </li>
                                    );
                                case 106: //라인
                                    return <li key={idx} className="line" />;
                                case 101: //방명록
                                    return (
                                        <li key={idx} className={classNames(getActive(`/${id}/guest`))}>
                                            <Link to={`/${id}/guest`} onClick={gtag("pc_menu", "guest")}>
                                                {menu.name}
                                            </Link>
                                        </li>
                                    );
                                default:
                                    //게시판
                                    return (
                                        <li key={idx} className={classNames(getActive(`/${id}/posts/${menu.bbs_no}`))}>
                                            <Link
                                                to={`/${id}/posts/${menu.bbs_no}`}
                                                onClick={gtag("pc_menu", "posts", null, menu.bbs_no)}
                                            >
                                                {menu.name}
                                            </Link>
                                        </li>
                                    );
                            }
                        })}

                    {/* {is_owner && [
                        (is_best_bj || is_partner_bj || is_sports_bj) && <li key={1} className="line" />,
                        is_best_bj && (
                            <li key={2}>
                                <a href="//bestbj.onlive.vn/" target="_blank" rel="noopener noreferrer">
                                    <Trans>tốt nhất BJ bảng ghi chú</Trans>
                                </a>
                            </li>
                        ),
                        is_partner_bj && (
                            <li key={3}>
                                <a href="//partnerbj.onlive.vn/" target="_blank" rel="noopener noreferrer">
                                    <Trans>cộng sự BJ bảng ghi chú</Trans>
                                </a>
                            </li>
                        ),
                        is_sports_bj && (
                            <li key={4}>
                                <a href="//sotong.onlive.vn/?board_type=sports" target="_blank" rel="noopener noreferrer">
                                    <Trans>các môn thể thao BJ bảng ghi chú</Trans>
                                </a>
                            </li>
                        ),
                    ]} */}
                </ul>
            </div>
        </article>,
    ];
}

export default Menu;